import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as DispatchWordMark } from './cot_Dispatch-wordmark-w.svg';

export function BrandIconWordMark() {
  return (
    <SvgIcon
      sx={{ fontSize: 221, my: -9.375, mx: -1.2 }}
      component={DispatchWordMark}
      inheritViewBox
    />
  );
}
